import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankCriteria, getBlankRecord, getBlankTransactionListing, getBlankDueRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_UNLOAD_SINGLE](state) {
    state.view.loaded = false;
  },
  [mutation.STATE_UNLOAD_LISTING](state) {
    state.listing.loaded = false;
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    stateMerge(state.listing.criteria, getBlankCriteria());
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_SET_FILTERS](state, { levyCollectionId, providerId }) {
    state.listing.levyCollectionId = levyCollectionId;
    state.listing.providerId = providerId;
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, results) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = results;
    state.listing.empty = results.length == 0 && !state.listing.criteriaInfo.hasCriteria;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_STARTED](state, invoiceId) {
    state.view.loading = true;
    state.view.loaded = false;
    state.view.invoiceId = invoiceId;
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
  },
  [mutation.VIEW_SUCCEEDED](state, invoice) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, invoice);
  },

  [mutation.RECONCILE_STARTED](state, invoiceId) {
    state.reconcile.loading = true;
    state.reconcile.invoiceId = invoiceId;
  },
  [mutation.RECONCILE_FAILED](state) {
    state.reconcile.loading = false;
  },
  [mutation.RECONCILE_SUCCEEDED](state) {
    state.reconcile.loading = false;
  },

  [mutation.RECONCILE_TESTING_TOOL_UPDATE](state, updates) {
    stateMerge(state.reconcileTestingTool.data, updates);
  },
  [mutation.RECONCILE_TESTING_TOOL_STARTED](state, invoiceId) {
    state.reconcileTestingTool.loading = true;
    state.reconcileTestingTool.invoiceId = invoiceId;
  },
  [mutation.RECONCILE_TESTING_TOOL_FAILED](state, error) {
    state.reconcileTestingTool.loading = false;
    state.reconcileTestingTool.error.show = true;
    state.reconcileTestingTool.error.details = error;
  },
  [mutation.RECONCILE_TESTING_TOOL_SUCCEEDED](state) {
    state.reconcileTestingTool.loading = false;
  },

  [mutation.GET_TRANSACTIONS_STARTED](state, invoiceId) {
    let t = state.transactions.find(t => t.invoiceId == invoiceId);
    if (t == null) {
      t = getBlankTransactionListing(invoiceId);
      state.transactions.push(t);
    }
    t.loading = true;
  },
  [mutation.GET_TRANSACTIONS_FAILED](state, invoiceId) {
    let t = state.transactions.find(t => t.invoiceId == invoiceId);
    t.loading = false;
    t.loaded = false;
  },
  [mutation.GET_TRANSACTIONS_SUCCEEDED](state, { transactions, invoiceId }) {
    let t = state.transactions.find(t => t.invoiceId == invoiceId);
    t.loading = false;
    t.loaded = true;
    t.data = transactions;
  },

  [mutation.DUE_GET_STARTED](state) {
    state.due.loading = true;
    state.due.data = getBlankDueRecord();
  },
  [mutation.DUE_GET_SUCCEEDED](state, dueData) {
    state.due.loading = false;
    stateMerge(state.due.data, dueData);
  },
  [mutation.DUE_GET_FAILED](state, error) {
    state.due.loading = false;
    state.due.error.show = true;
    state.due.error.details = error;
  },
  [mutation.DUE_SAVE_STARTED](state) {
    state.due.saving = true;
  },
  [mutation.DUE_SAVE_SUCCEEDED](state) {
    state.due.saving = false;
  },
  [mutation.DUE_SAVE_FAILED](state, error) {
    state.due.saving = false;
    state.due.error.show = true;
    state.due.error.details = error;
  },
  [mutation.DUE_SET_DATA](state, details) {
    stateMerge(state.due.data, details);
  }
};
